import React from 'react';
import PropTypes from 'prop-types';
import {
  LessonOutline,
  setupTokenProvider
} from '@ramsey-plus-components/learn-ui';
import tokenProviderFactory from 'src/api/token_provider';

const LessonOutlineContainer = ({ lesson }) => {
  const { action_groups: actionGroups, title, subtitle } = lesson;
  const tokenProvider = tokenProviderFactory();
  setupTokenProvider(tokenProvider);

  return (
    <LessonOutline
      actionGroups={actionGroups}
      title={title}
      lessonNumber={subtitle}
      compact={true}
    />
  );
};

LessonOutlineContainer.propTypes = {
  lesson: PropTypes.object.isRequired
};

export default LessonOutlineContainer;
